module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-red-right.e3dc85e5.svg";